<template>
<div :id="idName">
    <slot />
</div>
</template>

<script>
import download from 'downloadjs'

export default {
    props: {
        // mime type [xls, csv], default: xls
        'type': {
            type: String,
            default: "xls"
        },
        'fields': {
            type: Object,
            required: true
        },
        'title': {
            type: String,
            default: null
        },
        'name': {
            type: String,
            default: "data.xls"
        },
        'meta': {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            data: []
        }
    },

    computed: {
        // unique identifier
        idName: function () {
            let now = new Date()
                .getTime();
            return 'export_' + now;
        }
    },

    methods: {
        generate(data) {

            this.data = data;

            if(!this.data.length) {
                return
            }

            let json = this.getProcessedJson(this.data, this.fields);
            if(this.type === 'csv') {
                return this.export(this.jsonToCSV(json), this.name, "application/csv");
            }
            return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
        },

        //Use downloadjs to generate the download link
        export: function (data, filename, mime) {
            let blob = this.base64ToBlob(data, mime);
            download(blob, filename, mime)
        },

        jsonToXLS: function (data) {
            let xlsTemp =
                '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
            let xlsData = '<thead><tr>';

            if(this.title != null) {
                if(Array.isArray(this.title)) {
                    for(var i = 0; i < this.title.length; i++) {
                        xlsData += '<th colspan="' + Object.keys(data[0])
                            .length + '">' + this.title[i] + '<th></tr><tr>'
                    }
                } else {
                    xlsData += '<th colspan="' + Object.keys(data[0])
                        .length + '">' + this.title + '<th></tr><tr>'
                }
            }

            for(let key in data[0]) {
                xlsData += '<th>' + key + '</th>'
            }
            xlsData += '</tr></thead>';
            xlsData += '<tbody>';
            // eslint-disable-next-line
            data.map(function (item, index) {
                xlsData += '<tbody><tr>';
                for(let key in item) {
                    xlsData += '<td>' + item[key] + '</td>'
                }
                xlsData += '</tr></tbody>'
            });
            return xlsTemp.replace('${table}', xlsData)
        },

        jsonToCSV: function (data) {
            let csvData = '';

            if(this.title != null) {
                if(Array.isArray(this.title)) {
                    for(let i = 0; i < this.title.length; i++) {
                        csvData += this.title[i] + '\r\n'
                    }
                } else {
                    csvData += this.title + '\r\n'
                }
            }

            for(let key in data[0]) {
                csvData += key + ','
            }
            csvData = csvData.slice(0, csvData.length - 1);
            csvData += '\r\n';

            data.map(function (item) {
                for(let key in item) {
                    let escapedCSV = item[key] + '';
                    if(escapedCSV.match(/[,"\n]/)) {
                        // eslint-disable-next-line
                        escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
                    }
                    csvData += escapedCSV + ','
                }
                csvData = csvData.slice(0, csvData.length - 1);
                csvData += '\r\n'
            });
            return csvData
        },

        getProcessedJson: function (data, header) {
            let keys = this.getKeys(data, header);
            let newData = [];
            let _self = this;
            // eslint-disable-next-line
            data.map(function (item, index) {
                let newItem = {};
                for(let label in keys) {
                    let property = keys[label];
                    newItem[label] = _self.getNestedData(property, item)
                }
                newData.push(newItem)
            });

            return newData
        },

        getKeys: function (data, header) {
            if(header) {
                return header
            }

            let keys = {};
            for(let key in data[0]) {
                keys[key] = key
            }
            return keys
        },

        getNestedData: function (key, item) {
            const field = (typeof key === 'object') ? key.field : key;

            let valueFromNestedKey = null;
            let keyNestedSplit = field.split(".");

            valueFromNestedKey = item[keyNestedSplit[0]];
            for(let j = 1; j < keyNestedSplit.length; j++) {
                valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]]
            }

            valueFromNestedKey = this.callItemCallback(key, valueFromNestedKey);

            return valueFromNestedKey;
        },

        callItemCallback: function (field, itemValue) {
            if(typeof field === 'object' && typeof field.callback === 'function') {
                return field.callback(itemValue);
            }

            return itemValue;
        },

        base64ToBlob: function (data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
            let bstr = atob(base64);
            let n = bstr.length;
            let u8arr = new Uint8ClampedArray(n);
            while(n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
    } // end methods
}
</script>
